export const ACCESS_TOKEN = "@dukeAccessToken";

export const PRIVATE_MENU_ITEM_PATH = "@dukePrivateMenuItemPath";
